import type { ReactVirtualizer } from '@tanstack/react-virtual';
import { useLayoutEffect, useRef } from 'react';
import type { VirtualChatRow } from '../../../types';

type P = {
  rows: VirtualChatRow[];
  virtualizer: ReactVirtualizer<HTMLDivElement, Element>;
};

export const useScrollToLastSentMessageEffect = ({ rows, virtualizer }: P) => {
  const lastMessageRow = rows.findLast((row) => row.kind === 'message');
  const lastSeenMessageRow = useRef(lastMessageRow);

  useLayoutEffect(() => {
    if (
      lastMessageRow?.message.id !== lastSeenMessageRow.current?.message.id &&
      lastMessageRow?.direction === 'outgoing'
    ) {
      virtualizer.scrollToEnd();
    }

    lastSeenMessageRow.current = lastMessageRow;
  }, [lastMessageRow, virtualizer]);
};
